import { useEffect, useState } from "react";
import { isAuthenticated } from "../services/Auth";

export const useIsAuth = () => {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    (async () => {
      !(await isAuthenticated()) ? setIsAuth(false) : setIsAuth(true);
    })();
  });

  return isAuth;
};
